
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import SalePricesForm from '@/components/proposal/form/SalePricesForm.vue';
import { ProposalMutation } from '@/store/proposal/proposal.mutation';

export default defineComponent({
  name: "ProposalCreateReturns",
  components: {SalePricesForm},
  computed: {
    ...mapGetters(['returnsWeightBrackets', 'returnsRows']),
    grossMarginMutation(): string {
      return ProposalMutation.SETUP_RETURNS_GROSS_MARGIN;
    }
  }
})
